import { appLocale } from '../../../shared/model';
import type { seo } from '../../../shared/api';

const locale = appLocale.lib.getAppLocale();

export const getLocalizedPublicOffer = (
  pageContents: Array<seo.types.SeoPageContent>,
) => {
  return (
    pageContents.find(content => content.language === locale) || pageContents[0]
  );
};
